// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f5f9d6dd","513":"7fdeae47","703":"c29c3c18","787":"c96de55b"}[chunkId] + ".chunk.js";
};